import { render, staticRenderFns } from "./PlayerStatComponent.vue?vue&type=template&id=69bcdb67&scoped=true&"
import script from "./PlayerStatComponent.vue?vue&type=script&lang=js&"
export * from "./PlayerStatComponent.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStatComponent.vue?vue&type=style&index=0&id=69bcdb67&prod&lang=css&"
import style1 from "./PlayerStatComponent.vue?vue&type=style&index=1&id=69bcdb67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bcdb67",
  null
  
)

export default component.exports